<div class="modal">
  <div class="card card--md">
    <div class="card-header">
      <h3 class="card-title">Dodaj korisnika u email listu</h3>
    </div>
    <div class="card-body">
      <form [formGroup]="userForm">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Ime i prezime</label>
              <input type="text" 
                     class="form-control" 
                     name="name" 
                     formControlName="name" 
                     placeholder="Ime i prezime" 
                     [class.is-invalid]="f.name.touched && f.name.errors && f.name.errors.required" />
              <div class="invalid-feedback"
                   *ngIf="f.name.touched && f.name.errors && f.name.errors.required">
                Unesite ime korisnika
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label class="form-label">Email adresa</label>
              <input type="text" 
                     class="form-control" 
                     name="email" 
                     formControlName="email" 
                     placeholder="Email"
                     [class.is-invalid]="f.email.touched && f.email.errors && (f.email.errors.required || f.email.errors.email)" />
              <div class="invalid-feedback"
                   *ngIf="f.email.touched && f.email.errors && f.email.errors.required">
                Unesite email adresu
              </div>
              <div class="invalid-feedback"
                   *ngIf="f.email.touched && f.email.errors && f.email.errors.email">
                Email nije ispravan
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="form-group">    
              <label class="form-check pointer">
                <input class="form-check-input" 
                       type="checkbox"
                       formControlName="activate"
                       [checked]="f.activate.value">
                <span class="form-check-label">Sačuvaj u email listu</span>
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="userForm.invalid">Potvrdi</button>
    </div>
  </div>
</div>